import React from 'react';
import './MilkNewsletter2025.css';

const MilkNewsletter2025 = () => {
  return (
    <div className="milk-newsletter-container">
      <div className="milk-newsletter-content">
        <div className="header-section">
          <img 
            src="/img/nl1.png" 
            alt="Milk Decoration Logo" 
            className="milk-logo"
          />
          <div className="ampersand">&</div>
          <img 
            src="/img/nl2.jpg" 
            alt="Le French Design Logo" 
            className="partner-logo"
          />
        </div>

        <h1 className="main-title">
          Le FRENCH DESIGN : ConnectedBy, la plateforme bien pensée pour les professionnels du secteur
        </h1>

        <p className="intro-text">
          Le FRENCH DESIGN by VIA est né il y a plus de 40 ans. Ce projet a donné naissance à la plateforme ConnectedBy, un annuaire qui recense plus de 700 contacts, aussi bien des entreprises que des designers, des décorateurs… Une bonne façon de créer du lien entre les talents du pays et les éditeurs en quête de développer leurs activités autour du design. Entretien avec les designers Adrien Louvry & Thomas Angioni, fondateurs du studio Louvry & Angioni, tous les deux utilisateurs réguliers de la plateforme ConnectedBy de Le FRENCH DESIGN.
        </p>

        <div className="cta-button-container">
          <a href="https://connectedby.lefrenchdesign.org/" target="_blank" rel="noopener noreferrer" className="cta-button">
            ConnectedBy par Le FRENCH DESIGN
          </a>
        </div>

        <div className="image-container">
          <img 
            src="/img/nl3.png" 
            alt="Louvry & Angioni" 
            className="main-image"
          />
          <p className="image-caption">Louvry & Angioni</p>
        </div>

        <div className="interview-section">
          <div className="question-answer">
            <h3>Louvry & Angioni, qui êtes vous ? Quel est votre parcours et votre activité ?</h3>
            <p>
              Rencontrés sur les bancs de l'École supérieure de design de Troyes, nous avons fondé notre studio à Paris en 2015. Portés par la complémentarité de nos regards et de nos pratiques, nous explorons chaque projet à travers une approche transversale, où la forme et le signe dialoguent. Notre mission première est de créer des objets porteurs de sens, pensés avec sensibilité et pertinence, à l'intersection du design et de la direction artistique. Nous façonnons des formes qui ne se contentent pas d'exister, mais qui incarnent un équilibre entre esthétique, usage et récit.
            </p>
          </div>

          <div className="question-answer">
            <h3>Pouvez-vous revenir sur les pièces les plus emblématiques de votre répertoire ?</h3>
            <p>
              — La chaise Perluette, éditée par Cinna et Ligne Roset à l'international, a été pour nous une pièce fondatrice. Elle a conforté notre vision du design : une quête constante d'équilibre entre esthétique, usage et récit.
            </p>
            <p>
              — Le paravent Karel, qui représente parfaitement la fusion de nos deux univers, avec l'influence du travail graphique de Karel Martens et la poésie des objets d'Eileen Gray, en hommage à ces deux figures.
            </p>
            <p>
              — Notre travail de recherche autour du pli métallique, outil de prédilection de l'entreprise Matière Grise. Ce projet, resté à l'état de prototype, nous a néanmoins beaucoup appris sur les processus de développement d'un objet édité en France.
            </p>
            <p>
              — Enfin, notre projet actuel : la création d'une collection de canapés pour Marina Studio, un artisan du sur-mesure.
            </p>
          </div>

          <div className="image-grid">
            <img src="/img/nl4.jpg" />
          </div>
          <p className="image-caption">1. Matière Grise, 2 et 3. Marina Studio, 4. La chaise Perluette, éditée par Cinna et Ligne Roset</p>

          <div className="question-answer">
            <h3>Quand et par quel biais avez-vous découvert Le FRENCH DESIGN ?</h3>
            <p>
              Le FRENCH DESIGN a toujours fait partie de notre paysage. En tant que jeunes designers, nous allions régulièrement voir les expositions du VIA, son ancien nom. Cela nous permettait de rester informés sur l'actualité du design français, à une époque où les réseaux sociaux commençaient à émerger. Nous y avons découvert de potentiels partenaires industriels et éditeurs, alors même que nous lancions notre activité. Par la suite, nous avons participé aux speed-datings, qui nous ont permis de faire de très belles rencontres et d'initier des collaborations avec des entreprises françaises prestigieuses comme Matière Grise ou Habitat, par exemple.
            </p>
          </div>

          <div className="question-answer">
            <h3>À quelle fréquence utilisez-vous la plateforme ConnectedBy ?</h3>
            <p>
              Régulièrement, c'est un outil de travail agile et utile de manière hebdomadaire car elle intègre un annuaire français des éditeurs, des fabricants et institutionnels qui nous permet d'élargir notre réseau.
            </p>
          </div>

          <div className="question-answer">
            <h3>Selon vous, quel est son intérêt principal ?</h3>
            <p>
              Sa principale force réside dans sa capacité à jouer son rôle d'entremetteur, celui d'un véritable réseau. Elle facilite la mise en relation entre un studio de design comme le nôtre et différents interlocuteurs propres à notre profession.
            </p>
          </div>

          <div className="question-answer">
            <h3>Quels sont les outils et les services que vous trouvez les plus pertinents pour votre activité ?</h3>
            <p>
              L'outil que nous utilisons le plus est l'annuaire. Il est fluide, bien structuré, et constamment enrichi. Il agrège de nombreux profils – designers, prescripteurs, architectes – mais les sections éditeurs, fabricants, galeristes et distributeurs sont particulièrement précieuses pour nous, car elles regroupent nos interlocuteurs majeurs et récurrents.
            </p>
          </div>

          <div className="image-container">
            <img 
              src="/img/nl5.png" 
              alt="Le paravent Karel" 
              className="full-width-image"
            />
            <p className="image-caption">Le paravent Karel</p>
          </div>

          <div className="question-answer">
            <h3>Est-ce que ce service vous a permis des avancées particulières dans votre carrière ?</h3>
            <p>
              Il nous a permis de rencontrer des éditeurs et fabricants français formidables que nous n'aurions peut-être pas pu découvrir autrement, comme par exemple l'éditeur bordelais Metapoly avec qui nous développons actuellement des projets de tables et bancs en métal.
            </p>
          </div>

          <div className="question-answer">
            <h3>Quelles sont les particularités de cette refonte qui vous séduisent particulièrement ?</h3>
            <p>
              La fluidité et sa simplicité d'usage sont particulièrement agréables. C'est appréciable aussi de constater que Le FRENCH DESIGN attache une importance particulière à entretenir une relation privilégiée avec ses adhérents en nous proposant via l'onglet «événements», des actions personnalisées et adaptées à notre profil et nos compétences.
            </p>
          </div>

          <div className="image-container">
            <img 
              src="/img/nl6.jpg" 
              alt="La chaise bend" 
              className="full-width-image"
            />
            <p className="image-caption">La chaise bend</p>
          </div>

          <div className="question-answer">
            <h3>Pour quelles raisons recommandez-vous cette plateforme ?</h3>
            <p>
              Nous recommandons cette plateforme à tout designer français attaché à développer une activité et des projets qui valorisent nos industries, nos savoir-faire et nos institutions. Des ressources nationales précieuses qui méritent d'être mises en lumière.
            </p>
          </div>

          <div className="question-answer">
            <h3>Quels sont vos projets ?</h3>
            <p>
              Nous menons actuellement différents projets. Celui du moment est le développement d'une collection propre de canapés et bancs haut de gamme entièrement fabriqués en France de manière responsable avec le fabricant de siège Marina studio. Ce projet est incubé par Le FRENCH DESIGN et actuellement exposé dans leurs locaux, avenue Ledru-Rollin, jusqu'à fin septembre, dans le cadre de l'exposition Regards 2025.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilkNewsletter2025;